module.exports = __webpack_public_path__ + "static/kellerkindCover-14f87246d1614ff1cf339940bdc58186.jpg";